import { render, staticRenderFns } from "./product-modal.vue?vue&type=template&id=3e44273d&"
import script from "./product-modal.vue?vue&type=script&lang=js&"
export * from "./product-modal.vue?vue&type=script&lang=js&"
import style0 from "./product-modal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./product-modal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\employee-listing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e44273d')) {
      api.createRecord('3e44273d', component.options)
    } else {
      api.reload('3e44273d', component.options)
    }
    module.hot.accept("./product-modal.vue?vue&type=template&id=3e44273d&", function () {
      api.rerender('3e44273d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmployeeListing/components/product-modal.vue"
export default component.exports